import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice';
import projectReducer from './features/dashboard/projectSlice';
import serviceReducer from './features/dashboard/serviceSlice';
import blogReducer from './features/dashboard/blogSlice'
import jobReducer from './features/dashboard/JobSlice'
import jobApplicationsReducer from './features/dashboard/JobManagementSlice'
import adminUsersReducer from './features/dashboard/adminUsersSlice'
import messagesReducer from './features/dashboard/messagesSlice'
export const store = configureStore({
  reducer: {
    auth: authReducer,
    projects: projectReducer,
    services: serviceReducer,
    blogs:blogReducer,
    jobs:jobReducer,
    jobApplications: jobApplicationsReducer,  
    adminUsers:adminUsersReducer,  
    message:messagesReducer,
  },
});